@if (showWelcomeMessage) {
  <div class="top-dashboard-container">
    <div class="top-dashboard-welcome-header">
      <img
        [src]="'assets/icons/ccom-logo-svg/CCOM-Symbol-Blue.svg'"
        class="logo-image"
        alt="ccom logo"
        routerLink="/"
      />
      <h1>
        {{ 'welcomeToCCOMXNameSurname' | translate: { userNameAndSurname: userNameAndSurname } }}
      </h1>
    </div>
  </div>
}

@if (displayDashboard) {
  <div class="dashboard-widgets-container">
    <h1 class="dashboard-title">{{ 'dashboard' | translate }}</h1>
    <app-permit-to-work-dashboard-widgets></app-permit-to-work-dashboard-widgets>
    @if (canReadDocuments && readReceiptsEnabled()) {
      <app-document-read-receipts-dashboard-widget></app-document-read-receipts-dashboard-widget>
    }
    @if (canReadMaintenanceJob) {
      <app-maintenance-dashboard-widgets></app-maintenance-dashboard-widgets>
    }
    @if (canReadNC) {
      <app-reports-dashboard-widgets></app-reports-dashboard-widgets>
      <app-deviations-over-time></app-deviations-over-time>
    }
    <!-- TODO Illia: uncomment this when we're ready to proceed with severity sorting -->
    <!-- <div class="dashboard-row">
      <app-open-reports-section></app-open-reports-section>
      <app-jobs-critical-components></app-jobs-critical-components>
    </div> -->
  </div>
  <!-- TODO Illia: commented, maybe will be removed later https://dev.azure.com/ccomas/CCOM%20X/_workitems/edit/11172 -->
  <!-- <div class="dashboard-blocks-container">
    <span class="info-block light-blue-info-block info-hover" routerLink="/due-list">
      <div class="vertical-line blue-line"></div>
      <div class="info-block-details">
        <h1>{{ totalWarnings }}</h1>
        <h4>{{ 'totalWarnings' | translate }}</h4>
      </div>
    </span>
    <span class="info-block orange-info-block info-hover" routerLink="/non-conformances/open">
      <div class="vertical-line orange-vertical-line"></div>
      <div class="info-block-details">
        @if (canReadNC || isUserProductOwner) {
          <h1>{{ ncOpen }}</h1>
        } @else {
          N/A
        }
        <h4>{{ 'nonConfromancesOpen' | translate }}</h4>
      </div>
    </span>
    <span
      class="info-block light-green-info-block info-hover"
      routerLink="/non-conformances/completed"
    >
      <div class="vertical-line green-line"></div>
      <div class="info-block-details">
        @if (canReadNC || isUserProductOwner) {
          <h1>{{ ncCompleted }}</h1>
        } @else {
          N/A
        }
        <h4>{{ 'nonConformancesCompleted' | translate }}</h4>
      </div>
    </span>
    <span
      class="info-block light-blue-info-block info-hover"
      routerLink="/purchases/sentToSupplier"
    >
      <div class="vertical-line blue-line"></div>
      <div class="info-block-details">
        @if (canReadOrders || isUserProductOwner) {
          <h1>{{ ordersSentToSupplier }}</h1>
        } @else {
          N/A
        }
        <h4>{{ 'ordersSentToSupplier' | translate }}</h4>
      </div>
    </span>
    <span class="info-block light-red-info-block">
      <div class="vertical-line red-line"></div>
      <div class="info-block-details">
        <h1>{{ expiredWarnings }}</h1>
        <h4>{{ 'expiredWarnings' | translate }}</h4>
      </div>
    </span>
    <span class="info-block light-yellow-info-block">
      <div class="vertical-line yellow-line"></div>
      <div class="info-block-details">
        <h1>{{ soonExpiringWarnings }}</h1>
        <h4>{{ 'soonExpiringdWarnings' | translate }}</h4>
      </div>
    </span>
    <span class="info-block light-red-info-block">
      <div class="vertical-line red-line"></div>
      <div class="info-block-details">
        <h1>{{ expiredCompetences }}</h1>
        <h4>{{ 'expiredCompetences' | translate }}</h4>
      </div>
    </span>
    <span class="info-block light-yellow-info-block">
      <div class="vertical-line yellow-line"></div>
      <div class="info-block-details">
        <h1>{{ soonExpiringCompetences }}</h1>
        <h4>{{ 'soonExpiringCompetences' | translate }}</h4>
      </div>
    </span>
  </div> -->
}
